module.exports = __webpack_public_path__ + "static/img/KOBY-COULSON.8920bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KOBY-COULSON.jpg
// module id = 0Xj1
// module chunks = 0